// What a chord table is and how a command's chord is read from one. The shell's table is in
// chords.ts and the aligner's in align/core/chords.ts; the registry takes either.

export type Platform = 'mac' | 'windows'

export interface ChordRow {
  mac: string | null
  windows: string | null
  editor?: true
  /// Bound only where the system draws the menu bar: the browser keeps these chords for itself.
  native?: true
}

/// A row, or one chord for both platforms.
export type ChordSpec = string | ChordRow

/// Every command's default chords, by id.
export type ChordTable = Readonly<Record<string, ChordRow>>

/// A translator's rebinding, kept in local storage beside the layout. Null unbinds.
export type ChordOverrides = Record<string, string | null>

export function chordTable(spec: Readonly<Record<string, ChordSpec>>): ChordTable {
  return Object.fromEntries(Object.entries(spec).map(([id, s]) => [id, typeof s === 'string' ? { mac: s, windows: s } : s]))
}

export function chordIn(table: ChordTable, id: string, platform: Platform, overrides: ChordOverrides = {}, menus: 'page' | 'system' = 'page'): string | null {
  if (id in overrides) return overrides[id] ?? null
  const row = table[id]
  if (row?.native && menus !== 'system') return null
  return row?.[platform] ?? null
}

export function editorChordIn(table: ChordTable, id: string): boolean {
  return table[id]?.editor === true
}
